import { render } from "./Snail.vue?vue&type=template&id=98d4922e"
import script from "./Snail.vue?vue&type=script&lang=js"
export * from "./Snail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/userlevels/releases/14/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.40_vue@3.5.40_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__